export * from './IconChatGradient';
export { default as IconChatGradient } from './IconChatGradient';
